import { createAction } from '../../../utils/redux/createAction';

const actionsScope = 'patient-portal/share-to-email-modal';

export const SHARE_TO_EMAIL_MODAL = {
  OPEN: `${actionsScope}/open`,
  CLOSE: `${actionsScope}/close`,
};

export const shareToEmailModalActions = {
  open: createAction(SHARE_TO_EMAIL_MODAL.OPEN),
  close: createAction(SHARE_TO_EMAIL_MODAL.CLOSE),
};

const initialState = {
  opened: false,
  documentUid: '',
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case SHARE_TO_EMAIL_MODAL.OPEN: {
      return {
        ...state,
        documentUid: payload.documentUid,
        opened: true,
      };
    }

    case SHARE_TO_EMAIL_MODAL.CLOSE: {
      return { ...initialState };
    }

    default: {
      return state;
    }
  }
};



// WEBPACK FOOTER //
// ./src/redux/healthboard/patientPortal/share-to-email-modal.js